<template>
  <ol class="breadcrumb">
    <li class="breadcrumb-item" :key="index" v-for="(item, index) in breadcrumbs">
      <span v-if="(isLast(index) || item.to.name === '')" class="active">{{ item.title }}</span>
      <router-link v-else :to="item.to">{{ item.title }}</router-link>
    </li>
  </ol>
</template>

<script>
export default {
  name: 'c-breadcrumb',
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      breadcrumbs: []
    }
  },
  watch: {
    $route: {
      deep: true,
      handler (to, from) {
        this.createBreadcrumbs(this.list, from.params)
      }
    }
  },
  created () {
    this.createBreadcrumbs(this.list, this.$route.params)
  },
  methods: {
    isLast (index) {
      return index === this.breadcrumbs.length - 1
    },
    createBreadcrumbs (list, params) {
      this.breadcrumbs = []
      const names = []
      const reversedList = list.slice().reverse()
      // eslint-disable-next-line no-unused-vars
      for (const item of reversedList) {
        if (names.indexOf(item.meta.label) === -1) {
          names.push(item.meta.label)
          let name = item.name
          if (item.name === '' && item.redirect) {
            name = item.redirect
          }
          this.breadcrumbs.push({
            to: { name, params },
            title: item.meta.label
          })
        }
      }

      this.breadcrumbs.reverse()
    }
  }
}
</script>
